import { memo, useState, forwardRef, useImperativeHandle } from 'react';

import { StyledSection } from '../style';

const scrollMt = 20;

const LeftNav = forwardRef((props, ref) => {
  const { leftNavList, left, scrollTop } = props;
  const [activeCode, setActiveCode] = useState(leftNavList[0].frontPartitionCode);
  const [isProgrammaticScroll, setIsProgrammaticScroll] = useState(false);

  const changeActive = (item) => {
    setActiveCode(item.frontPartitionCode);
    setIsProgrammaticScroll(true);
    const scrollY = window.scrollY;
    const dom = document.querySelector(`#${item.frontPartitionName}-content`);
    window.scrollTo({
      top: dom?.getBoundingClientRect()?.top + scrollY - 72 - scrollMt,
      behavior: 'smooth',
    });
    setTimeout(() => {
      setIsProgrammaticScroll(false);
    }, 1000);
  };

  const setLeftNavPosition = () => {
    if (isProgrammaticScroll) return;
    const scrollY = window.scrollY;
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    const offset = 30; // 距底部 30px 时触发最后一个高亮
    const heightArr = [];
    leftNavList.forEach((item) => {
      const dom = document.querySelector(`#${item.frontPartitionName}-content`);
      if (dom) {
        heightArr.push({
          frontPartitionCode: item.frontPartitionCode,
          height: dom?.getBoundingClientRect()?.top + scrollY - 72 - scrollMt,
        });
      }
    });
    let activeCodeState = activeCode;
    if (scrollY === 0) {
      activeCodeState = leftNavList[0].frontPartitionCode;
    } else if (scrollTop + clientHeight >= scrollHeight - offset) {
      activeCodeState = leftNavList[leftNavList.length - 1].frontPartitionCode;
    } else {
      heightArr.some((item, index) => {
        if (
          scrollY >= item.height &&
          (!heightArr[index + 1] || (heightArr[index + 1] && scrollY < heightArr[index + 1]?.height))
        ) {
          activeCodeState = item.frontPartitionCode;
          return true;
        }
        return false;
      });
    }
    setActiveCode(activeCodeState || leftNavList?.[leftNavList?.length - 1]?.frontPartitionCode);
  };

  const toTop = (frontPartitionCode) => {
    setIsProgrammaticScroll(true);
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    setActiveCode(frontPartitionCode);
    setTimeout(() => {
      setIsProgrammaticScroll(false);
    }, 1000);
  };

  useImperativeHandle(ref, () => ({
    setLeftNavPosition,
    toTop,
  }));

  return (
    <StyledSection
      className={`fixed left-[0] top-[390px] w-[150px] ${scrollTop > 500 ? 'start' : ''}`}
      style={{
        left: left - 150 - 20,
      }}
    >
      <div className={'text-[14px] text-[#333333] text-right flex flex-col'}>
        {leftNavList.map((item) => {
          return (
            <div
              key={item.frontPartitionCode}
              className={`h-[44px] pr-[21px] leading-[44px] cursor-pointer  border-solid border-r-[2px] ${activeCode === item.frontPartitionCode ? 'text-[#0093E6] border-[#0094E5]' : 'border-[#F1F1F1]'} hover:text-[#0094E5] hover:border-[#0094E5]`}
              onClick={() => changeActive(item)}
            >
              {item.frontPartitionName}
            </div>
          );
        })}
      </div>
    </StyledSection>
  );
});

LeftNav.displayName = LeftNav;

export default memo(LeftNav);
